import { SubMenu } from "react-pro-sidebar";
import { useEffect, useRef, useCallback } from "react";
import Item from "../item";

const Practice = ({
  lookupcodetype, title, sections, subPart, subPartCode, 
  inspectionUid, selected, setSelected, colors, filterRegulations, 
  existRegulationWithNoCitation, filterCitationLanguages, lookups}) => {
  
  const hasUserInteracted = useRef(false);
  const previousLookups = useRef(null);
  
  // Reset user interaction flag when lookups data changes (new navigation context)
  useEffect(() => {
    if (previousLookups.current !== lookups?.short_citation_language_description) {
      hasUserInteracted.current = false;
      previousLookups.current = lookups?.short_citation_language_description;
    }
  }, [lookups?.short_citation_language_description]);
  
  // Handle automatic selection when lookups data is available
  useEffect(() => {
    if (lookups?.short_citation_language_description && !hasUserInteracted.current) {
      setSelected(lookups.short_citation_language_description);
    }
  }, [lookups?.short_citation_language_description, setSelected]);
  
  // Enhanced setSelected that tracks user interaction
  const handleUserSelection = useCallback((title) => {
    hasUserInteracted.current = true;
    setSelected(title);
  }, [setSelected]);
  
  return (
    <SubMenu
      key={lookupcodetype}
      title={title}
      style={{
        color: colors.grey[100],
      }}
      defaultOpen={lookups?.lookup_code_type && lookups?.lookup_code_type === lookupcodetype}
    >
      {sections &&
        sections.map((section, index) => {
          if (subPart !== section.parent_uid) {
            subPart = section.parent_uid;
            subPartCode = section.parent_code;
            return (
              <SubMenu
                key={section.parent_uid}
                title={section.parent_description}
                style={{
                  color: colors.grey[100],
                }}
                defaultOpen={section?.parent_description?.includes(lookups?.sub_part_description)}
              >
                {sections
                  .filter((item) => item.parent_uid === section.parent_uid)
                  .map((filterSection) => {
                    return (
                      <SubMenu key={filterSection.lookup_uid} title={filterSection.description}
                        defaultOpen={filterSection.description.includes(lookups?.section_description)}
                        >
                        {filterRegulations(filterSection.lookup_uid).map((filterRegulation) => {
                          if (existRegulationWithNoCitation(filterRegulation.regulation_code)) {
                            return <Item key={filterRegulation.lookup_uid} title={filterRegulation.description_with_regulation} to={`/inspection/${inspectionUid}/citationLanguageCode/${filterRegulation.regulation_code}`} selected={selected} setSelected={handleUserSelection} />;
                          } else {
                            return (
                              <SubMenu key={filterRegulation.lookup_uid} title={filterRegulation.description_with_regulation}
                              defaultOpen={filterRegulation.description_with_regulation.includes(lookups?.sub_section_description)}>
                                {filterCitationLanguages(filterRegulation.regulation_lookup_uid).map((filterCitationLanguage) => (
                                  <Item key={filterCitationLanguage.lookup_uid} title={filterCitationLanguage.description} to={`/inspection/${inspectionUid}/subPartCode/${subPartCode}/citationLanguageCode/${filterCitationLanguage.code}/lookupcodetype/${lookupcodetype}`} selected={selected} setSelected={handleUserSelection} />
                                ))}
                              </SubMenu>
                            );
                          }
                        })}
                      </SubMenu>
                    );
                  })}
              </SubMenu>
            );
          } else {
            return <div key={section.parent_uid + index}></div>;
          }
        })}
    </SubMenu>
  );
};

export default Practice;
